import { action } from "satcheljs";
import { IGroupedOpenShiftRequestEntity } from "sh-models";

const loadDataForGroupedRequest = action(
    "LOAD_DATA_FOR_GROUPED_REQUEST",
    (groupedRequest: IGroupedOpenShiftRequestEntity) => ({ groupedRequest: groupedRequest })
);

export default loadDataForGroupedRequest;